var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapStreetViewPanorama',{ref:"streetView",staticStyle:{"width":"100%","height":"500px"},attrs:{"position":_vm.position,"pov":{heading: 165, pitch: 0},"zoom":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }